// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './icon.module.scss';

// = Types & Constants =
import { IconProps } from './icon.types';
import ICONS from '@/constants/icons';

const Icon: FC<IconProps> = (props) => {
  const { type = 'file', color = 'dark', className = '', title = '', subtitle = '' } = props;

  // Находим иконку-компонент в списке иконок по типу, который будет передан в пропсы
  const Icon = ICONS[type];

  return (
    <div
      className={clsx(
        {
          [classes['icon']]: true,
          [classes['icon--with-text']]: title || subtitle,
        },
        className
      )}>
      <Icon color={color} />

      <div
        className={clsx({
          [classes.icon__text]: title || subtitle,
        })}>
        {title && <span className={classes.icon__title}>{title}</span>}
        {subtitle && (
          <span
            className={clsx({
              [classes['icon__subtitle']]: true,
              [classes['icon__subtitle--bold']]: !title,
            })}>
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

export default Icon;
